import { API } from "@/services"

export const PLANS_ENDPOINTS = {
  list(params={}){
    return API.Axios.humanify.v1.request({
      url: `admin/plans`,
      method: 'GET',
      params,
    })
  },
  getById(id='',params={}){
    return API.Axios.humanify.v1.request({
      url: `admin/plans/${id}`,
      method: 'GET',
      params,
    })
  },
  update(id='',data={}){
    return API.Axios.humanify.v1.request({
      url: `admin/plans/${id}`,
      method: 'PUT',
      data,
    })
  },
}